export default __webpack_public_path__ + "static/media/logo-axa.5cad8fbf.svg";